























import { Component, Mixins, Prop} from "vue-property-decorator";
import { NumberInput } from "../../../../../base/components/system";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IThresholdAlertBehavior } from "../../../../domain/format/objects";

@Component({
  components: {
    NumberInput,
  }
})
export default class ThresholdAlertEditor extends Mixins(ModelEditableMixin) {
  // 負の数を使用するためNumber.MIN_SAFE_INTEGERを使用する
  // 最小値、最大値の指標のため、小数点以下の入力は可能
  @Prop({ default: (Number.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1)) }) // MIN_SAFE_INTEGERはIEは未定義のため
  minThreshold: number;

  @Prop({ default: (Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1) })    // MAX_SAFE_INTEGERはIEは未定義のため
  maxThreshold: number;

  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IThresholdAlertBehavior<number>) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IThresholdAlertBehavior<number>) => T, defaultValue: T) => T;

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get threshold(): number {
    return this.readPropertyOrDefault(s => s.threshold, 0);
  }

  set threshold(value: number) {
    this.writePropertyWhenValid(s => s.threshold = ((value !== 0) && !value) ? 0 : value);
  }

  get isColorEnable(): boolean {
    return this.readPropertyOrDefault(s => s.alertByStyle.isEnable, false);
  }

  set isColorEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.alertByStyle.isEnable = value);
  }

  get color(): string {
    return this.readPropertyOrDefault(s => s.alertByStyle.color.value, null);
  }

  set color(value: string) {
    this.writePropertyWhenValid(s => s.alertByStyle.color.value = value ? value : undefined);
  }

  isValid(value: number): boolean {
    return (this.minThreshold <= value) && (value <= this.maxThreshold) && ((this.threshold !== 0) || (value === 0) || !!value);
  }
}
